import { DEMO_SCHEDULES } from '@/data/pulseDemo/demoSchedules'
import { DEMO_TRIGGERS } from '@/data/pulseDemo/demoTriggers'

const SOURCES = new Map([
  ...DEMO_SCHEDULES.map((item) => [item.id, { ...item, kind: 'schedule' }]),
  ...DEMO_TRIGGERS.map((item) => [item.id, { ...item, kind: 'trigger' }]),
])

/** The sample schedule or trigger an update came from, tagged with its kind. */
export const findDemoSource = (id) => SOURCES.get(id) ?? null
